import "./styles.css";
import "bootstrap/dist/css/bootstrap.css";
import PdfDownloadComponent from "./PdfDownloadComponent";

export default function App() {
  return (
    <div className="App">
      <PdfDownloadComponent />
    </div>
  );
}
